import { TopicAccessLevel } from "$/stores/extension/ActiveTopicStore";
export class CommentMentions {
    constructor() {
        this.mentions = [];
        this.initialMemberMentions = [];
        this.initialMentionsWithRole = [];
        this.initialSlackMentions = [];
    }
    addMention(mention) {
        if (!this.mentions.find((m) => m.id === mention.id)) {
            this.mentions.push(mention);
        }
    }
    setInitialMentions(editorInput) {
        this.initialMemberMentions = this.parseMemberMentions(editorInput);
        this.initialMentionsWithRole = this.parseMentionsWithRole(editorInput);
        this.initialSlackMentions = this.parseSlackMentions(editorInput);
    }
    rebuildMentionsList(editorInput) {
        let memberMenitons = this.parseMemberMentions(editorInput);
        let mentionsWithRole = this.parseMentionsWithRole(editorInput);
        let slackMentions = this.parseSlackMentions(editorInput);
        //removing mention from initalMention array when it's deleted in the comment
        this.initialMemberMentions = this.initialMemberMentions.filter((initialMention) => memberMenitons.some((mentionedUser) => initialMention.user.id === mentionedUser.user.id));
        this.initialMentionsWithRole = this.initialMentionsWithRole.filter((initialMention) => mentionsWithRole.some((mentionedEmail) => initialMention.user.username ===
            mentionedEmail.user.username));
        this.initialSlackMentions = this.initialSlackMentions.filter((initialMention) => slackMentions.some((mentionedSlack) => initialMention.user.id === mentionedSlack.user.id));
        let initialMentions = [
            ...this.initialMemberMentions,
            ...this.initialMentionsWithRole,
        ];
        let mentionedMembers = removeMemberMentionsDuplicates(memberMenitons, initialMentions);
        let mentionedNewMembers = removeMentionsWtihRoleDuplicates(mentionsWithRole, mentionedMembers, initialMentions);
        let mentionedNonMembers = removeSlackMentionsDuplicates(slackMentions, mentionedNewMembers, this.initialSlackMentions);
        this.mentions = [
            ...mentionedMembers,
            ...mentionedNewMembers,
            ...mentionedNonMembers,
        ];
        return this;
    }
    getMentionedMembers() {
        return this.mentions
            .filter((mention) => !mention.topicRole)
            .map((mention) => mention.user);
    }
    getCreateAndMentionMembers() {
        return this.mentions.filter((mention) => mention.topicRole &&
            mention.topicRole.role !== TopicAccessLevel.MENTION);
    }
    getMentionedNonMembers() {
        return this.mentions
            .filter((mention) => { var _a; return ((_a = mention.topicRole) === null || _a === void 0 ? void 0 : _a.role) === TopicAccessLevel.MENTION; })
            .map((mention) => mention.user);
    }
    changeAllRolesToMentionOnly() {
        this.mentions = this.mentions.map((mention) => {
            return Object.assign(Object.assign({}, mention), { topicRole: Object.assign(Object.assign({}, mention.topicRole), { role: TopicAccessLevel.MENTION }) });
        });
    }
    getMentionsWithRole() {
        return this.mentions.filter((mention) => mention.topicRole);
    }
    clear() {
        this.mentions = [];
        this.initialMemberMentions = [];
        this.initialMentionsWithRole = [];
        this.initialSlackMentions = [];
    }
    parseMentionsWithRole(editorInput) {
        return packMentions(this.parseEditorsMentionsWithRole(editorInput), true);
    }
    parseEditorsMentionsWithRole(editorInput) {
        let parsedSlackMentions = (editorInput.content || []).flatMap((mentions) => this.parseEditorsMentionsWithRole(mentions));
        if (editorInput.type === "mention" &&
            editorInput.attrs.username &&
            !editorInput.attrs.isMember) {
            let mentionRole = this.mentions.find((mentionRole) => mentionRole.topicRole &&
                mentionRole.topicRole.user.id === editorInput.attrs.id);
            parsedSlackMentions.push({
                id: editorInput.attrs.id,
                username: editorInput.attrs.username,
                slackWorkspaceId: editorInput.attrs.slackWorkspaceId,
                role: mentionRole
                    ? mentionRole.topicRole.role
                    : editorInput.attrs.role
                        ? editorInput.attrs.role
                        : TopicAccessLevel.MENTION,
            });
        }
        return parsedSlackMentions;
    }
    parseMemberMentions(editorInput) {
        let parsedUserMentions = (editorInput.content || []).flatMap((mentions) => this.parseMemberMentions(mentions));
        if (editorInput.type === "mention" &&
            editorInput.attrs.isMember &&
            !editorInput.attrs.slackWorkspaceId) {
            parsedUserMentions.push({
                user: {
                    id: editorInput.attrs.id,
                    username: editorInput.attrs.username,
                },
            });
        }
        return parsedUserMentions;
    }
    parseSlackMentions(editorInput) {
        return packMentions(this.parseSlackMentionsFromEditor(editorInput));
    }
    parseSlackMentionsFromEditor(editorInput) {
        let parsedSlackMentions = (editorInput.content || []).flatMap((mentions) => this.parseSlackMentionsFromEditor(mentions));
        if (editorInput.type === "mention" &&
            editorInput.attrs.id &&
            editorInput.attrs.slackUserId &&
            editorInput.attrs.slackWorkspaceId) {
            parsedSlackMentions.push({
                id: editorInput.attrs.id,
                username: editorInput.attrs.username,
                slackWorkspaceId: editorInput.attrs.slackWorkspaceId,
            });
        }
        return parsedSlackMentions;
    }
}
function packMentions(parsedEditorMentions, mentionsWithRole = false) {
    return parsedEditorMentions.reduce((parsedMentions, mention) => {
        var _a;
        let existingUser = parsedMentions.find((el) => el.user.id && el.user.id === mention.id);
        if (existingUser != undefined) {
            let exisitingWorkspaceIndex = (_a = existingUser.user.memberOfSlackWorkspaces) === null || _a === void 0 ? void 0 : _a.findIndex((workspace) => workspace.id === mention.slackWorkspaceId);
            if (exisitingWorkspaceIndex < 0) {
                existingUser.user.memberOfSlackWorkspaces.push({
                    id: mention.slackWorkspaceId,
                });
                if (mentionsWithRole)
                    existingUser.topicRole.user.memberOfSlackWorkspaces =
                        existingUser.user.memberOfSlackWorkspaces;
            }
        }
        else {
            let user = {
                id: mention.id,
                username: mention.username,
                memberOfSlackWorkspaces: mention.slackWorkspaceId
                    ? [{ id: mention.slackWorkspaceId }]
                    : null,
            };
            if (mentionsWithRole) {
                parsedMentions.push({
                    user,
                    topicRole: { user, role: mention.role },
                });
            }
            else {
                parsedMentions.push({ user });
            }
        }
        return parsedMentions;
    }, []);
}
function removeMemberMentionsDuplicates(mentionedMembers, initialMentions) {
    //removes duplicates and mentions that where already present (applicable only if the user is editing a comment)
    return mentionedMembers.filter((mentionedUser, index) => !initialMentions.some((initialMention) => mentionedUser.user.id === initialMention.user.id ||
        mentionedUser.user.username ===
            initialMention.user.username) &&
        mentionedMembers.findIndex((mention) => mention.user.id === mentionedUser.user.id) === index);
}
function removeMentionsWtihRoleDuplicates(mentionedNewMembers, mentionedMembers, initialMentions) {
    //removes duplicates, mentions that where already present (applicable only if the user is editing a comment) and existing user's mentions
    return mentionedNewMembers.filter((emailMention, index) => !initialMentions.some((initialMention) => initialMention.user.username === emailMention.user.username) &&
        !mentionedMembers.some((mentionedUser) => mentionedUser.user.username === emailMention.user.username) &&
        mentionedNewMembers.findIndex((mention) => mention.user.username === emailMention.user.username) === index);
}
function removeSlackMentionsDuplicates(slackMentions, mentionedNewMembers, initialSlackMentions) {
    return slackMentions.filter((slackMention) => !initialSlackMentions.some((initialMention) => initialMention.user.id === slackMention.user.id) &&
        mentionedNewMembers.findIndex((mentionedNewMember) => {
            return (mentionedNewMember.user.id === slackMention.user.id &&
                mentionedNewMember.user.memberOfSlackWorkspaces &&
                mentionedNewMember.user.memberOfSlackWorkspaces.some((mentionedNewMemberWorkspace) => slackMention.user.memberOfSlackWorkspaces.findIndex((slackMentionWorkspace) => slackMentionWorkspace.id ===
                    mentionedNewMemberWorkspace.id) >= 0));
        }) === -1);
}
